var _path, _path2, _path3, _rect, _path4, _rect2, _rect3, _circle, _rect4, _circle2, _rect5, _circle3, _rect6, _rect7, _path5, _circle4, _circle5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 232h150",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 63h335",
    stroke: "#E0E4E9",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145 232v-16",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 34,
    width: 338,
    height: 181,
    rx: 7,
    stroke: "#627A92",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195 232v-16",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 41,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#E0E4E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 44,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 48.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 44,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 48.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 44,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#E0E4E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 48.5,
    r: 4.5,
    fill: "#E0E4E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 1,
    width: 66,
    height: 66,
    rx: 7,
    fill: "#fff",
    stroke: "#627A92",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 15,
    width: 38,
    height: 38,
    rx: 5,
    fill: "#C72D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291 22v14",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 44,
    r: 3,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 125,
    r: 24,
    stroke: "#627A92",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m188 143 21.213 21.213",
    stroke: "#627A92",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotFound);
export default __webpack_public_path__ + "static/media/errorNotFound.6ab4d1756845d7a636e5e38dd89c8509.svg";
export { ForwardRef as ReactComponent };